export const DELAY_TYPES = [
  { title: 'Cut Media', value: '1' },
  { title: 'After Media', value: '2' },
];